// Module
var code = `
  <h2 class="section-header">General</h2>
  <form name="\$ctrl.generalForm">
    <table class="table">
      <thead>
      <tr>
        <th></th>
        <th>Property</th>
        <th>Value</th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="property in \$ctrl.properties">
        <td>{{ \$index + 1}}.</td>
        <td>{{property.code | translate:'SYSTEM_PROPERTY_DESCRIPTION'}}:</td>
        <td ng-if="property.type === 'number' && property.min !== undefined">
          <glue-container append="property.unit" title="{{property.tooltip}}">
            <input required
                   type="number"
                   ng-model="property.value"
                   ng-min="property.min"
                   ng-max="property.max"
                   ng-disabled="!\$ctrl.changeAllowed"/>
          </glue-container>
        </td>
        <td ng-if="property.type === 'multiselect'">
          <multiselect
              items="property.possibleValues"
              ng-model="property.multiValue"
              label-property="'label'"
              value-property="'value'"
              ng-disabled="!\$ctrl.changeAllowed"
          >
          </multiselect>
        </td>
        <td ng-if="property.type === 'select'">
          <select ng-model="property.value"
                  ng-disabled="!\$ctrl.changeAllowed"
                  required
                  ng-options="entry.value as entry.label for entry in property.possibleValues">
          </select>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="security-general__control-buttons buttons" command-access="ChangeSecurityProperties">
      <button
          type="submit"
          class="btn btn-success"
          ng-disabled="\$ctrl.generalForm.\$invalid"
          ng-click="\$ctrl.save()">
        Save changes
      </button>
    </div>
  </form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/security-general/security-general.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;